export enum LessonStatus {
    LESSON_CREATED = 0,
    LESSON_IN_WORK = 1,
    LESSON_COMPLETED = 2,
    LESSON_CANCELED = 3,
    LESSON_PRE_CREATED = 4,
    LESSON_COMPLETED_NOT_FINAL = 5
}

export const STATUS_LABELS: Map<number, string> = new Map([
    [LessonStatus.LESSON_CREATED, 'Готово'],
    [LessonStatus.LESSON_IN_WORK, 'Не завершено'],
    [LessonStatus.LESSON_COMPLETED, 'Завершено'],
    [LessonStatus.LESSON_CANCELED, 'Не проведено'],
    [LessonStatus.LESSON_PRE_CREATED, 'Не готово'],
    [LessonStatus.LESSON_COMPLETED_NOT_FINAL, 'Приостановлено']
]);

export const STATUS_CLASSES = {
    [LessonStatus.LESSON_IN_WORK]: 'inwork',
    [LessonStatus.LESSON_CREATED]: 'created',
    [LessonStatus.LESSON_COMPLETED]: 'completed',
    [LessonStatus.LESSON_CANCELED]: 'cancelled',
    [LessonStatus.LESSON_PRE_CREATED]: 'precreated',
    [LessonStatus.LESSON_COMPLETED_NOT_FINAL]: 'notfinal'
};
export enum EventType {
    EVENT_UNKNOWN = 0,
    EVENT_START_LESSON = 1,
    EVENT_END_LESSON = 2,
    EVENT_ENTER_ANSWER = 3,
    EVENT_PUPIL_ENTER = 4,
    EVENT_PUPIL_SELECT_CARD = 5,
    EVENT_PUPIL_EXIT = 6
}

export enum CardStatus {
    CARD_COMPLETED = 'completed',
    CARD_NEW = 'new'
}

export enum AFormat {
    A7_FORMAT = 'A7',
    A6_FORMAT = 'A6',
    A5_FORMAT = 'A5',
    A3_FORMAT = 'A3'
}

export enum TaskStatus {
    TASK_SUCCESS = 'SUCCESS',
    TASK_PENDING = 'PENDING',
    TASK_FAILED = 'FAILED'
}

export enum TransactionOperation {
    CASH_IN = 1,
    CASH_OUT = -1
}
